import Icon, { IconName } from './Icon';
import { SidebarIncidentSummary } from './SidebarIncidentSummary';

interface SidebarProps {
  currentPage: string;
  isAdmin?: boolean;
  onDashboard: () => void;
  onReport: () => void;
  onAdvisor: () => void;
  onTraining: () => void;
  onStaffRoster: () => void;
  onRoster: () => void;
  onAllIncidents: () => void;
}

type NavItem = { key: string; label: string; icon: IconName; onClick: () => void; active: boolean };

export function Sidebar(p: SidebarProps) {
  const items: NavItem[] = [
    { key: 'dashboard', label: 'Dashboard',      icon: 'grid',    onClick: p.onDashboard, active: p.currentPage === 'dashboard' },
    { key: 'training',  label: 'Training',       icon: 'cap',     onClick: p.onTraining,  active: p.currentPage === 'training' },
    { key: 'advisor',   label: 'Crisis Advisor', icon: 'message', onClick: p.onAdvisor,   active: p.currentPage === 'advisor' },
  ];
  if (p.isAdmin) {
    items.push(
      { key: 'staff',  label: 'Staff & Roster', icon: 'users',    onClick: p.onStaffRoster, active: p.currentPage === 'settings' },
    );
  }

  return (
    <aside className="cs-sidebar">
      <div className="cs-brand">
        <img src="/crisis-logo.png" alt="" />
        <div>
          <div className="nm">CRISIS SHIELD</div>
          <div className="sub">CIMA Console</div>
        </div>
      </div>

      <button className="cs-report" data-tour="nav.report" onClick={p.onReport}>
        <Icon name="plus" size={17} />
        Report Incident
      </button>

      <div className="cs-navlabel">Menu</div>
      {items.map((it) => (
        <button key={it.key} data-tour={`nav.${it.key}`} className={`cs-navitem${it.active ? ' active' : ''}`} onClick={it.onClick}>
          <Icon name={it.icon} size={19} className="cs-ic" />
          {it.label}
        </button>
      ))}

      <div className="cs-sidebar-spacer" />

      <SidebarIncidentSummary />
    </aside>
  );
}
